export default "__VITE_ASSET__ebe6e16a__"